// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content-header {
  display: flex;
  justify-content: space-between;
  flex-flow: column;
}
.content-header .sub-nav-container {
  display: flex;
  flex-basis: 100%;
}
.content-header .sub-nav-container .sub-nav-left,
.content-header .sub-nav-container .sub-nav-right {
  min-height: 5rem;
  width: 100%;
  flex-basis: 50%;
  justify-content: center;
}
.content-header .data-container {
  display: flex;
  justify-content: space-between;
  gap: 2rem;
}
.content-header .data-container .left-data {
  flex-basis: 80%;
}
.content-header .data-container .left-data .description-content {
  margin-bottom: 5rem;
}
.content-header .data-container .left-data .description-content button.catalog-link {
  border: none;
  background-color: transparent;
  color: blue;
  text-decoration: underline;
  margin-left: 2rem;
  cursor: alias;
}
.content-header .data-container .left-data h2,
.content-header .data-container .left-data h4 {
  display: inline-block;
  font-size: 3.6rem;
  margin-bottom: 1.4rem;
}
.content-header .data-container .left-data h4 {
  font-weight: normal;
}
.content-header .data-container .left-data h2 {
  font-weight: 700;
  padding-right: 1rem;
}
.content-header .data-container .left-data .head-description {
  margin-bottom: 2.3rem;
  font-size: 1.6rem;
  line-height: 2.2rem;
}
.content-header .data-container .left-data .head-description :not(:last-child) {
  margin-bottom: 2.2rem;
}
.content-header .data-container .right-data {
  display: flex;
  flex-flow: column;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/kit/components/ContentHeader/index.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,8BAAA;EACA,iBAAA;AACF;AACE;EACE,aAAA;EACA,gBAAA;AACJ;AACI;;EAEE,gBAAA;EACA,WAAA;EACA,eAAA;EACA,uBAAA;AACN;AAGE;EACE,aAAA;EACA,8BAAA;EACA,SAAA;AADJ;AAGI;EACE,eAAA;AADN;AAGM;EACE,mBAAA;AADR;AAGQ;EACE,YAAA;EACA,6BAAA;EACA,WAAA;EACA,0BAAA;EACA,iBAAA;EACA,aAAA;AADV;AAKM;;EAEE,qBAAA;EACA,iBAAA;EACA,qBAAA;AAHR;AAMM;EACE,mBAAA;AAJR;AAOM;EACE,gBAAA;EACA,mBAAA;AALR;AAQM;EACE,qBAAA;EACA,iBAAA;EACA,mBAAA;AANR;AAQQ;EACE,qBAAA;AANV;AAWI;EACE,aAAA;EACA,iBAAA;EACA,uBAAA;AATN","sourcesContent":[".content-header {\n  display: flex;\n  justify-content: space-between;\n  flex-flow: column;\n\n  .sub-nav-container {\n    display: flex;\n    flex-basis: 100%;\n\n    .sub-nav-left,\n    .sub-nav-right {\n      min-height: 5rem;\n      width: 100%;\n      flex-basis: 50%;\n      justify-content: center;\n    }\n  }\n\n  .data-container {\n    display: flex;\n    justify-content: space-between;\n    gap: 2rem;\n\n    .left-data {\n      flex-basis: 80%;\n\n      .description-content {\n        margin-bottom: 5rem;\n\n        button.catalog-link {\n          border: none;\n          background-color: transparent;\n          color: blue;\n          text-decoration: underline;\n          margin-left: 2rem;\n          cursor: alias;\n        }\n      }\n\n      h2,\n      h4 {\n        display: inline-block;\n        font-size: 3.6rem;\n        margin-bottom: 1.4rem;\n      }\n\n      h4 {\n        font-weight: normal;\n      }\n\n      h2 {\n        font-weight: 700;\n        padding-right: 1rem;\n      }\n\n      .head-description {\n        margin-bottom: 2.3rem;\n        font-size: 1.6rem;\n        line-height: 2.2rem;\n\n        :not(:last-child) {\n          margin-bottom: 2.2rem;\n        }\n      }\n    }\n\n    .right-data {\n      display: flex;\n      flex-flow: column;\n      justify-content: center;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
